import { ICONS_STYLE } from '@/utils/constants';
import React from 'react';

interface IconProps {
    name: string;
    className?: string;
    style?: React.CSSProperties; // Allow passing custom styles to the icon
}

export const Icon: React.FC<IconProps> = ({ name, className = '', style }) => {
    const { family, weight } = ICONS_STYLE; // Assuming ICONS_STYLE is defined somewhere in your configuration
    const iconUrl = `/icons/svg/${family}/${weight}/${name}.svg`;

    return (
        <span
            className={`inline-block align-middle bg-current ${className}`}
            style={{
                width: '1em',  // Take the width from the font size of the parent element
                height: '1em', // Take the height from the font size of the parent element
                WebkitMask: `url('${iconUrl}') no-repeat center / contain`,
                mask: `url('${iconUrl}') no-repeat center / contain`,
                ...style
            }}
            aria-hidden="true"
        />
    );
};